import React, { memo } from "react";
import ReactDOM from "react-dom";
import GenericPageButton from "./Button/GenericPageButton";

const themeUtil = require("../../utils/view/themeUtil");
const translator = require("../../utils/translator/translator");
const navigationHandler = require("./navigationHandler");

const AllPageMenuModal = ({ onClose = () => {} }) => {
     const handleOnClose = () => {
          onClose();
     };

     return ReactDOM.createPortal(
          <div
               onClick={handleOnClose}
               style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#00000080", backdropFilter: "blur(10px)" }}
          >
               <AllPageMenuModalContent />
          </div>,
          document.getElementById("root")
     );
};

export default memo(AllPageMenuModal);

const AllPageMenuModalContent = () => {
     let pages = themeUtil.getResolvedPages();
     let allButtons = [];
     pages.forEach(p =>
     {
          allButtons = allButtons.concat(p.buttons);
     })

     let noOfButtonsInARow = 6;
     let rowButtons = [];
     let components = [];
     allButtons.forEach(button =>
     {
          rowButtons.push(<AllPageMenuButton caption={button} />);
          if (rowButtons.length >= noOfButtonsInARow)
          {
               components.push(<div className="d-flex flex-row gap-3 p-3 rounded-4 " style={{ backgroundColor: "#ffffff50" }}>{rowButtons}</div>)
               rowButtons = [];
          } 
     })

     if (rowButtons.length >= 0)
     {
          components.push(<div className="d-flex flex-row gap-3 p-3 rounded-4 " style={{ backgroundColor: "#ffffff50" }}>{rowButtons}</div>)
     } 


     return (
          <div className="d-flex align-items-center h-100">
               <div className="d-flex flex-row align-items-center justify-content-center h-100 overflow-auto flex-wrap p-5 gap-4">
                    {components}
               </div>
               
          </div>
     );
};

const AllPageMenuButton = ({ caption }) => {
     const button = themeUtil.getResolvedButton(caption);

     return (
          <GenericPageButton
               caption={translator.getLabel(caption)}
               onClick={() => {
                    navigationHandler.handleNavigationButtonOnClick(button);
               }}
               button={button}
               size={window.innerWidth / 8}
               imageSize={window.innerWidth * 0.035}
          />
     );
};
